import { watch } from 'vue'
import { useOidcAuth } from '#imports'
import { useOnboardingTourSettings } from '~/composables/onboarding/useOnboardingTourSettings'

/**
 * Charge l’activation globale des guides pas à pas pour l’utilisateur connecté.
 */
export default defineNuxtPlugin(() => {
  const { loggedIn } = useOidcAuth()
  const { refresh, reset } = useOnboardingTourSettings()

  watch(
    loggedIn,
    (isLoggedIn) => {
      if (!isLoggedIn) {
        reset()
        return
      }
      void refresh()
    },
    { immediate: true }
  )
})
